module.exports = __webpack_public_path__ + "assets/img/0605.d82eeba0.png";